<template>
  <div class="code-container">
    <div class="code-title">{{codeData.name}}</div>
    <div class="code-editor">
      <code-editor ref="_firstRefs"
                   class="editor h-100 editor-left-container"
                   :isReadOnly="isReadOnly"
                   :value="editorContent"
                   :language="lang"></code-editor>
    </div>
  </div>
</template>
<script>
import codeEditor from "../components/codeEditor.vue";
import { get } from "@/utils/http";
export default {
  data() {
    return {
      editorContent: "",
      lang: "",
      leftContainerSize: 40,
      isReadOnly: true,
    };
  },
  props: ["codeData"],
  components: {
    codeEditor,
  },
  methods: {
    parseSourceCode(code) {
      return code.replace(/\/\*[\w\W]*?\*\//, "").trim();
    },
    frefresh() {
      // console.log("aaa");
      this.editorContent = "";
      let that = this;
      setTimeout(() => {
        get(that.codeData.url)
          .then((data) => {
            that.lang = that.codeData.lang;
            if (that.codeData.lang != "json") {
              that.editorContent = that.parseSourceCode(data);
            } else {
              that.editorContent = that.parseSourceCode(
                JSON.stringify(data, null, 2)
              );
            }
            // console.log(that.editorContent);
          })
          .catch((err) => {
            console.log(err);
          });
      }, 20);
    },
  },
  mounted() {
    // console.log(this.$route.query);

    this.frefresh();
  },
};
</script>
<style lang="scss" scoped>
.code-container {
  width: 95%;
  margin: 40px auto;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  background-color: #fff;
  .code-title {
    padding: 20px 0 0 10px;
    display: flex;
    font-size: 1.5rem;
  }
}

::v-deep .editor-left-container {
  height: 600px !important;
  position: static;
  width: 100%;
  margin: auto;
  .ace-editor-main {
    position: static;
    height: 95%;
    box-shadow: none;
    > div {
      border-radius: 0px;
    }
  }
}

.example-pane {
  height: 600px;
  padding: 10px;
  #example-page {
    height: 100%;
    width: 100%;
    border: 0px;
  }
}
</style>